module.exports = __webpack_public_path__ + "img/mail.2a3314ad.svg";